import Vue from 'vue'
import Router from 'vue-router'
// import Page404 from '@/components/Page404'
import Job from '@/components/Job'
import Booking from '@/components/Booking'
import Welcome from '@/components/Welcome'
import LineGroup from '@/components/LineGroup'
import TCG from '@/components/TCG'
import Events from '@/components/Events'
import Rating from '@/components/Rating'
import Message from '@/components/Message'
import ex10 from '@/components/ex10'
import OhRich from '@/components/OhRich'
import Kiosk from '@/components/Kiosk'
import ChatMe from '@/components/ChatMe'
import Vela from '@/components/Vela'
import TheMall from '@/components/TheMall'
import Martech2026 from '@/components/Martech2026'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Welcome.Home,
      meta: {
        title: 'หน้าหลัก'
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Welcome.Register,
      meta: {
        title: 'สมัคร'
      }
    },
    {
      path: '/CreateLineOAaccount',
      name: 'CreateLineOAaccount',
      component: Welcome.CreateLineOAaccount
    },
    {
      path: '/Login',
      name: 'Login',
      component: LineGroup.Login,
      meta: {
        title: 'ล็อคอิน',
        // ถ้าจะเปลี่ยน icon ให้เอา link มาใส่ในตัวแปร icon
        icon: 'https://betaskthai.com/wp-content/uploads/2020/03/cropped-LOGO_BeTask-website2.png'
      }
    },
    {
      path: '/RegisterClose',
      name: 'RegisterClose',
      component: Welcome.RegisterClose
    },
    {
      path: '/EmClose',
      name: 'EmClose',
      component: Welcome.EmClose
    },
    {
      path: '/UserSubmit',
      name: 'UserSubmit',
      component: Welcome.UserSubmit
    },
    {
      path: '/ManageShop',
      name: 'ManageShop',
      component: Welcome.ManageShop
    },
    {
      path: '/rating',
      name: 'rating',
      component: Job.rating
    },
    {
      path: '/OnsiteRating',
      name: 'OnsiteRating',
      component: Job.OnsiteRating
    },
    {
      path: '/JobConfirm',
      name: 'jobConfirm',
      component: Job.jobConfirm
    },
    {
      path: '/stampFirstStep',
      name: 'stampFirstStep',
      component: Job.stampFirstStep
    },
    {
      path: '/stampStep',
      name: 'stampStep',
      component: Job.stampStep
    },
    {
      path: '/Booking',
      name: 'Booking',
      component: Booking.Booking
    },
    {
      path: '/EditBooking',
      name: 'EditBooking',
      component: Booking.EditBooking
    },
    {
      path: '/BookingForm',
      name: 'BookingForm',
      component: Booking.BookingForm
    },
    {
      path: '/BookingFormKruBeer',
      name: 'BookingFormKruBeer',
      component: Booking.BookingFormKruBeer
    },
    {
      path: '/JoyrideReview',
      name: 'JoyrideReview',
      component: Booking.JoyrideReview
    },
    {
      path: '/BookingFormNoLine',
      name: 'BookingFormNoLine',
      component: Booking.BookingFormNoLine
    },
    {
      path: '/BookingQrcodeCheckConfirmJob',
      name: 'BookingQrcodeCheckConfirmJob',
      component: Booking.BookingQrcodeCheckConfirmJob
    },
    {
      path: '/BookingFormEmp',
      name: 'BookingFormEmp',
      component: Booking.BookingFormEmp
    },
    {
      path: '/BookingFormAutoEmp',
      name: 'BookingFormAutoEmp',
      component: Booking.BookingFormAutoEmp
    },
    {
      path: '/BookingFormEmpNoLine',
      name: 'BookingFormEmpNoLine',
      component: Booking.BookingFormEmpNoLine
    },
    {
      path: '/CalendarBookingAutoEmp',
      name: 'CalendarBookingAutoEmp',
      component: Booking.CalendarBookingAutoEmp
    },
    {
      path: '/BookingAddress',
      name: 'BookingAddress',
      component: Booking.BookingAddress
    },
    {
      path: '/ConditionFlow',
      name: 'ConditionFlow',
      component: Booking.ConditionFlow
    },
    {
      path: '/UserHistory',
      name: 'UserHistory',
      component: Booking.UserHistory
    },
    {
      path: '/SaveLineUserId',
      name: 'SaveLineUserId',
      component: Booking.SaveUserIdEmployee
    },
    {
      path: '/BookingQrcode',
      name: 'BookingQrcode',
      component: Booking.BookingQrcode
    },
    {
      path: '/BookingField',
      name: 'BookingField',
      component: Booking.BookingField
    },
    {
      path: '/Thank',
      name: 'Thank',
      component: Booking.Thank
    },
    {
      path: '/PaymentUpload',
      name: 'PaymentUpload',
      component: Booking.PaymentUpload
    },
    {
      path: '/ConfirmUser',
      name: 'ConfirmUser',
      component: Booking.ConfirmUser
    },
    {
      path: '/CheckQueueStoreFrontOhRich',
      name: 'CheckQueueStoreFrontOhRich',
      component: Booking.CheckQueueStoreFrontOhRich
    },
    {
      path: '/CheckQueueStoreFrontPopMart',
      name: 'CheckQueueStoreFrontPopMart',
      component: Booking.CheckQueueStoreFrontPopMart
    },
    {
      path: '/CheckQueueStoreFrontEvent',
      name: 'CheckQueueStoreFrontEvent',
      component: Booking.CheckQueueStoreFrontEvent
    },
    {
      path: '/CheckQueueStoreFrontKioskS',
      name: 'CheckQueueStoreFrontKioskS',
      component: Booking.CheckQueueStoreFrontKioskS
    },
    {
      path: '/CheckBookingLatest',
      name: 'CheckBookingLatest',
      component: Booking.CheckBookingLatest
    },
    {
      path: '/CheckQueueStoreFront',
      name: 'CheckQueueStoreFront',
      component: Booking.CheckQueueStoreFront
    },
    {
      path: '/CheckQueuePribta21',
      name: 'CheckQueuePribta21',
      component: Booking.CheckQueuePribta21
    },
    {
      path: '/CheckQueueStoreFrontPos',
      name: 'CheckQueueStoreFrontPos',
      component: Booking.CheckQueueStoreFrontPos
    },
    {
      path: '/CheckQueueStoreFrontToDayByLineUser',
      name: 'CheckQueueStoreFrontToDayByLineUser',
      component: Booking.CheckQueueStoreFrontToDayByLineUser
    },
    {
      path: '/CheckRealdyQueueStoreFront',
      name: 'CheckRealdyQueueStoreFront',
      component: Booking.CheckRealdyQueueStoreFront
    },
    {
      path: '/CalendarBookingNoLine',
      name: 'CalendarBookingNoLine',
      component: Booking.CalendarBookingNoLine
    },
    {
      path: '/CalendarBookingEmpNoLine',
      name: 'CalendarBookingEmpNoLine',
      component: Booking.CalendarBookingEmpNoLine
    },
    {
      path: '/CalendarBookingAutoEmpNoLine',
      name: 'CalendarBookingAutoEmpNoLine',
      component: Booking.CalendarBookingAutoEmpNoLine
    },
    {
      path: '/BookingFormAutoEmpNoLine',
      name: 'BookingFormAutoEmpNoLine',
      component: Booking.BookingFormAutoEmpNoLine
    },
    {
      path: '/CalendarBooking',
      name: 'CalendarBooking',
      component: Booking.CalendarBooking
    },
    {
      path: '/CalendarBookingEmp',
      name: 'CalendarBookingEmp',
      component: Booking.CalendarBookingEmp
    },
    {
      path: '/CalendarBookingEmp2',
      name: 'CalendarBookingEmp2',
      component: Booking.CalendarBookingEmp2
    },
    {
      path: '/CheckBookingNext',
      name: 'CheckBookingNext',
      component: Booking.CheckBookingNext
    },
    {
      path: '/Realtimequeue',
      name: 'Realtimequeue',
      component: Booking.Realtimequeue
    },
    {
      path: '/EmpList',
      name: 'EmpList',
      component: Booking.EmpList
    },
    {
      path: '/UpdateLineUserID',
      name: 'UpdateLineUserID',
      component: Booking.UpdateLineUserID
    },
    {
      path: '/test',
      name: 'test',
      component: Booking.Test
    },
    {
      path: '/EventRegister',
      name: 'EventRegister',
      component: Events.EventRegister
    },
    {
      path: '/Events',
      name: 'Events',
      component: Events.Events
    },
    {
      path: '/tcg/doctorlist',
      name: 'TCG_DoctorList',
      component: TCG.EmpList,
      meta: {
        title: 'TCG - One Stop Sevice'
      }
    },
    {
      path: '/tcg/BookingFormEmp',
      name: 'TCG_BookingFormEmp',
      component: TCG.BookingFormEmp,
      meta: {
        title: 'TCG - One Stop Sevice'
      }
    },
    {
      path: '/tcg/Thank',
      name: 'TCG_Thank',
      component: TCG.Thank,
      meta: {
        title: 'TCG - One Stop Sevice'
      }
    },
    {
      path: '/RatingAnswer',
      name: 'RatingAnswer',
      component: Rating.RatingAnswer,
      meta: {
        title: 'Rating Service'
      }
    },
    {
      path: '/RatingView',
      name: 'RatingView',
      component: Rating.RatingView,
      meta: {
        title: 'Rating Service'
      }
    },
    {
      path: '/MessageStart',
      name: 'MessageStart',
      component: Message.MessageStart
    },
    {
      path: '/ex10/CheckBookingNext',
      name: 'EX10_CheckBookingNext',
      component: ex10.CheckBookingNext
    },
    {
      path: '/OhRich/SelectFlowByBranch',
      name: 'SelectFlowByBranch',
      component: OhRich.SelectFlowByBranch
    },
    {
      path: '/OhRich/UpdateNotiLinaOA',
      name: 'UpdateNotiLinaOA',
      component: OhRich.UpdateNotiLinaOA
    },
    {
      path: '/Kiosk/SelectFlowByBranch',
      name: 'SelectFlowByBranch',
      component: Kiosk.SelectFlowByBranch
    },
    {
      path: '/Kiosk/UpdateNotiLinaOA',
      name: 'UpdateNotiLinaOA',
      component: Kiosk.UpdateNotiLinaOA
    },
    {
      path: '/BookingFormEmpEx10',
      name: 'BookingFormEmpEx10',
      component: Booking.BookingFormEmpEx10
    },
    {
      path: '/BookingFormAutoEmpEx10',
      name: 'BookingFormAutoEmpEx10',
      component: Booking.BookingFormAutoEmpEx10
    },
    {
      path: '/BookingFormEx10',
      name: 'BookingFormEx10',
      component: Booking.BookingFormEx10
    },
    {
      path: '/BookingSwitch',
      name: 'BookingSwitch',
      component: Booking.BookingSwitch
    },
    {
      path: '/DetailBookingEx10',
      name: 'DetailBookingEx10',
      component: Booking.DetailBookingEx10
    },
    {
      path: '/BookingFormChatMe',
      name: 'BookingFormChatMe',
      component: Booking.BookingFormChatMe
    },
    {
      path: '/DetailBookingChatMe',
      name: 'DetailBookingChatMe',
      component: Booking.DetailBookingChatMe
    },
    {
      path: '/BookingFormEmpChatMe',
      name: 'BookingFormEmpChatMe',
      component: Booking.BookingFormEmpChatMe
    },
    {
      path: '/BookingFormAutoEmpChatMe',
      name: 'BookingFormAutoEmpChatMe',
      component: Booking.BookingFormAutoEmpChatMe
    },
    {
      path: '/BookingSwitchChatMe',
      name: 'BookingSwitchChatMe',
      component: Booking.BookingSwitchChatMe
    },
    {
      path: '/BookingHistoryChatMe',
      name: 'BookingHistoryChatMe',
      component: Booking.BookingHistoryChatMe
    },
    {
      path: '/BookingHistoryEx10',
      name: 'BookingHistoryEx10',
      component: Booking.BookingHistoryEx10
    },
    {
      path: '/BookingHistory',
      name: 'BookingHistory',
      component: Booking.BookingHistory
    },
    {
      path: '/ChatMe/BookingMain',
      name: 'ChatMeBookingMain',
      component: ChatMe.BookingMain
    },
    {
      path: '/ChatMe/BookingForm',
      name: 'ChatMeBookingForm',
      component: ChatMe.BookingForm
    },
    {
      path: '/ChatMe/BookingFormEmp',
      name: 'ChatMeBookingFormEmp',
      component: ChatMe.BookingFormEmp
    },
    {
      path: '/ChatMe/CalendarBooking',
      name: 'ChatMeCalendarBooking',
      component: ChatMe.CalendarBooking
    },
    {
      path: '/ChatMe/CalendarBookingEmp',
      name: 'ChatMeCalendarBookingEmp',
      component: ChatMe.CalendarBookingEmp
    },
    {
      path: '/ChatMe/Thank',
      name: 'ChatMeThank',
      component: ChatMe.Thank
    },
    {
      path: '/ChatMe/BookingHistory',
      name: 'ChatMeBookingHistory',
      component: ChatMe.BookingHistory
    },
    {
      path: '/BookingSelect',
      name: 'BookingSelect',
      component: Booking.BookingSelect
    },
    {
      path: '/CalendarBookingBBQPlaza',
      name: 'CalendarBookingBBQPlaza',
      component: Booking.CalendarBookingBBQPlaza
    },
    {
      path: '/ShareFlex',
      name: 'ShareFlex',
      component: Booking.ShareFlex
    },
    {
      path: '/ShareFlowStep',
      name: 'ShareFlowStep',
      component: Booking.ShareFlowStep
    },
    {
      path: '/CalendarBookingEmpVela',
      name: 'CalendarBookingEmpVela',
      component: Vela.CalendarBookingEmpVela
    },
    {
      path: '/Shop',
      name: 'Shop',
      component: Booking.Shop
    },
    {
      path: '/TheMall/BookingForm',
      name: 'BookingForm',
      component: TheMall.BookingForm
    },
    {
      path: '/TheMall/BookingFormNoline',
      name: 'BookingFormNoline',
      component: TheMall.BookingFormNoLine
    },
    {
      path: '/Martech2026/register',
      name: 'Martech2026Register',
      component: Martech2026.register
    },
    {
      path: '/Martech2026/confirmBooking',
      name: 'Martech2026ConfirmBooking',
      component: Martech2026.confirmBooking
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js